/* global G */
import { curry, isStr } from 'lib/util'
import countries from 'model/address/collection/country'

/**
 * Returns only the props in `item` that are also listed in `keys`.
 *
 * @param {string[]} keys
 * @param {Object} item
 * @returns {*|{[p: string]: *}|{}}
 */
const filterByProps = (keys, item) => Object.keys(item).reduce((acc, prop) => (keys.includes(prop)
  ? { ...acc, [prop]: item[prop] }
  : acc), {})

/**
 * Returns the translated list of countries.
 *
 * @param {string[]} keys                         list of keys to include in the final list
 * @param {Gaia.AppModule.Spec} module            the current module object composition
 * @param {Gaia.Component} component              the object composition of the component that
 *                                                triggered the event handler
 * @param {Gaia.PlatformEvent|string} eventOrKey  the event or the key of the country to obtain
 * @returns {Object[]} countries
 */
// eslint-disable-next-line no-unused-vars
const listCountries = (keys, module, component, eventOrKey) => {
  const key = eventOrKey?.detail?.key || eventOrKey
  const scope = key && isStr(key) ? countries.filter(item => item.key === key) : countries

  const list = scope
    .map(item => (!keys?.length ? item : filterByProps(keys, item)))
    .map(item => ({
      ...item,
      key: item.key,
      value: module[G.ADAPTER][G.INTL]._t(
        `country.${item.key}`,
        { ns: 'generic', _key: `country.${item.key}`, defaultValue: item.value },
      ),
    }))

  return list.sort((a, b) => a.value.localeCompare(b.value))
}

/**
 * Returns the translated list of countries with all additional properties.
 *
 * @type {(function(...[*]): (*))|*}
 */
export const listFullCountries = curry((module, component, event) => listCountries([], module, component, event))

export default curry((module, component, event) => listCountries(['key', 'value'], module, component, event))
